import { routerPostCall } from '../../axios';

export const saveQuoteStepDataUrl = `/accounts/guest/quotes/step-data`;

// Persists one wizard step's fields onto the quote identified by policyToken
// (stored server-side under formSteps.<stepKey>).
const saveQuoteStepData = (state, params) => {
  const url = saveQuoteStepDataUrl;
  return routerPostCall(state, url, params, { allowGuestSession: true });
};

export default { saveQuoteStepData };
